import { RefObject, useMemo, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColTemplate from '@gym-templates/TwoColTemplate/TwoColTemplate';
import { AlertType } from '@gym-atoms/Alert/Alert';
import { Card } from 'primereact/card';
import { useAppSelector } from '@gym-redux/store';
import { GymChainAccessCategory } from '../../../particles/types/GymChainAccessCategory';
import GymChainAccessCategoryInfoTemplate from '../../templates/GymChainAccessCategoryInfo/GymChainAccessCategoryInfo';

const MainColumn = (props: { alertRef: RefObject<AlertType> }) => {
  const { gymChainAccessCategoryId, chainId } = useParams<{
    gymChainAccessCategoryId: string;
    chainId: string;
  }>();
  console.log(gymChainAccessCategoryId, chainId);

  const gymChainAccessCategory = useAppSelector((state) =>
    state.gymChainAccessCategories.items
      .find((g) => g.siteId === +chainId)
      ?.items.find((g) => g.id === +gymChainAccessCategoryId)
  );
  console.log({ gymChainAccessCategory });
  const { t } = useTranslation();
  const [
    gymChainAccessCategoryState,
    setGymChainAccessCategoryState
  ] = useState<GymChainAccessCategory>();

  const createGymChainAccessCategory = async () => {
    const items = {
      id: gymChainAccessCategory?.id || 0,
      siteId: gymChainAccessCategory?.siteId || 0,
      name: gymChainAccessCategory?.name || '',
      gender: gymChainAccessCategory?.gender || '',
      age: gymChainAccessCategory?.age || 0,
      schedulesOnly: gymChainAccessCategory?.schedulesOnly ? 'true' : 'false',
      status: gymChainAccessCategory?.status || '',
      gyms: [],
      memberships: []
    };
    console.log({ items });

    setGymChainAccessCategoryState(items);
  };

  useMemo(() => {
    createGymChainAccessCategory();
  }, []);

  return (
    <Card className="pt30 pl40 pr40 pb30">
      <GymChainAccessCategoryInfoTemplate
        alertRef={props.alertRef}
        alertMessage={t('MODIFY_MEMBERSHIP.ALERT_MESSAGE_SUCCESS')}
        accessCategory={gymChainAccessCategoryState}
        type={'modify'}
      />
    </Card>
  );
};

const ModifyGymChainAccessCategoryPage = () => {
  const { t } = useTranslation();
  const alertRef = useRef<AlertType>(null);
  const history = useHistory();
  const { chainId } = useParams<{ chainId: string }>();

  return (
    <TwoColTemplate
      title={t('MODIFY_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      gymChainId={+chainId}
      col1={<MainColumn alertRef={alertRef} />}
      alertRef={alertRef}
      backButtonHandler={() => history.push(`/gymChains/${chainId}/gymChainAccessCategories`)}
    />
  );
};
export default ModifyGymChainAccessCategoryPage;
